import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './auth-config';

export class MsalInstanceProvider {
  private static _instance: PublicClientApplication;

  public static getInstance() {
    if (!MsalInstanceProvider._instance) {
      MsalInstanceProvider._instance = new PublicClientApplication(msalConfig);
    }
    return MsalInstanceProvider._instance;
  }
}
